import type { FC } from '../../lib/teact/teact';
import { memo } from '../../lib/teact/teact';
import { getActions } from '../../global';

import { RASITECH_ADMIN_URL, RASITECH_ADMIN_USERNAME } from '../../rasitech/constants';
import { openRasiTelegramLink } from '../../util/openRasiLink';

import useLastCallback from '../../hooks/useLastCallback';

import Button from '../ui/Button';

const RasiBlockedScreen: FC = () => {
  const { signOut } = getActions();

  const handleSignOut = useLastCallback(() => {
    signOut({ forceInitApi: true });
  });

  return (
    <div className="rasi-blocked-screen full-height">
      <div className="rasi-blocked-screen-content">
        <h1>Akses ditolak</h1>
        <p dir="auto">
          Akun Anda diblokir dari Nusantara Messager. Hubungi admin
          {' '}
          <strong>@{RASITECH_ADMIN_USERNAME}</strong>
          {' '}
          jika ini kesalahan.
        </p>
        <Button onClick={() => openRasiTelegramLink(RASITECH_ADMIN_URL)} ripple>
          Hubungi admin
        </Button>
        <Button isText onClick={handleSignOut}>
          Keluar
        </Button>
      </div>
    </div>
  );
};

export default memo(RasiBlockedScreen);
